module.exports = __webpack_public_path__ + "static/p_shruti-3d0dc5bc477d215f52e66c629747c777.jpg";